import React, { useState, useContext, useRef, useEffect } from "react";
import { ThemeContext } from "styled-components";

import Icon from "konnekt/Icon";
import { getFileType } from "util/utility";
import Box from "konnekt/Box";
import useOnKeyPress from "customHooks/useOnKeyPress";
import { ARROW_LEFT, ARROW_RIGHT, ESC } from "constants/KeyboardKeys";
import Footer from "./Footer";
import ImageSection from "./MediaSection";
import Header from "./Header";
import {
  OuterContainer,
  Container,
  ControlsRow,
  IconBox,
  Text,
  Slider,
} from "./ImageViewerStyles";

const ImageViewer = ({
  data,
  show,
  activeItem,
  setActiveItem,
  handleClose,
  dataList,
  ...props
}) => {
  const themeContext = useContext(ThemeContext);
  const containerRef = useRef();

  const source = data?.src ?? (dataList && dataList[activeItem]?.src);
  const name = data?.name ?? (dataList && dataList[activeItem]?.name);

  const [rotate, setRotate] = useState(0);

  const [sliderValue, setSliderValue] = useState(0);

  const handleRotateClick = () => {
    setRotate(rotate + 90);
  };

  const handleSetActiveItem = (value) => {
    if (value >= 0 && value < dataList.length) {
      setActiveItem(value);
    }
  };

  useOnKeyPress([ESC], containerRef, handleClose);
  useOnKeyPress([ARROW_LEFT], containerRef, () =>
    handleSetActiveItem(activeItem - 1),
  );
  useOnKeyPress([ARROW_RIGHT], containerRef, () =>
    handleSetActiveItem(activeItem + 1),
  );

  useEffect(() => {
    setRotate(0);
    setSliderValue(0);

    if (containerRef.current) {
      containerRef.current.focus();
    }
  }, [containerRef, activeItem]);

  const renderRotateBtn = () => {
    if (getFileType(source) === "Image") {
      return (
        <IconBox display={{ _: "none", mobileL: "flex" }}>
          <Icon
            iconName="rotateRight"
            height="16px"
            width="16px"
            color={themeContext.colors.white}
            onClick={handleRotateClick}
            data-tip="Rotate"
            data-for="rotateRight"
          />
        </IconBox>
      );
    }

    return null;
  };

  const renderSlider = () => {
    if (getFileType(source) === "Image") {
      return (
        <IconBox alignSelf="stretch" alignItems="center" ml="5px">
          <Slider
            type="range"
            min="0"
            max="200"
            step="10"
            value={sliderValue}
            onChange={(e) => setSliderValue(e.target.value)}
          />
        </IconBox>
      );
    }

    return null;
  };

  const renderText = () => {
    if (name) {
      return <Text>{name}</Text>;
    }

    return null;
  };

  if (!show) {
    return null;
  }

  return (
    <OuterContainer onClick={handleClose} {...props}>
      <Container
        tabIndex="1"
        ref={containerRef}
        onClick={(e) => e.stopPropagation()}
      >
        <Header
          handleClose={handleClose}
          onRotateClick={handleRotateClick}
          data={data ?? (dataList && dataList[activeItem])}
        />

        <Box pt="24px" width="100%">
          <ImageSection
            dataList={dataList}
            data={data}
            activeItem={activeItem}
            setActiveItem={handleSetActiveItem}
            rotate={rotate}
            sliderValue={sliderValue}
            mt="24px"
          />
        </Box>

        <Box width="100%" mt="auto">
          <ControlsRow dataList={!!dataList}>
            {renderRotateBtn()}
            {renderSlider()}
          </ControlsRow>

          {renderText()}

          {dataList && (
            <Footer
              activeItem={activeItem}
              setActiveItem={handleSetActiveItem}
              dataList={dataList}
              data={data}
              rotate={rotate}
            />
          )}
        </Box>
      </Container>
    </OuterContainer>
  );
};

ImageViewer.defaultProps = {
  activeItem: 0,
};

export default ImageViewer;
